import { render } from "./walletMenuPcIndex.vue?vue&type=template&id=6454b922"
import script from "./walletMenuPcIndex.vue?vue&type=script&lang=js"
export * from "./walletMenuPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__